(function() {
  var params = new URLSearchParams(window.location.search);
  if (params.has("judgeme_review_source") || params.has("judgeme_token")) {
    function loadV2AndInit() {
      var s = document.createElement("script");
      s.src = "https://cdn.judge.me/shopify_v2.js";
      s.onload = function() {
        var pid = document.querySelector("[data-product-id]");
        var productId = pid ? pid.getAttribute("data-product-id") : "";
        var carousel = document.querySelector(".jdgm-carousel");
        if (carousel) {
          var div = document.createElement("div");
          div.className = "jdgm-widget jdgm-review-widget";
          div.id = "judgeme_product_reviews";
          if (productId) div.setAttribute("data-product-id", productId);
          div.setAttribute("data-product-title", document.title);
          div.setAttribute("data-product-url", window.location.pathname);
          carousel.parentNode.insertBefore(div, carousel.nextSibling);
        }
        if (typeof jdgm !== "undefined" && typeof jdgm.initializeWidgets === "function") {
          jdgm.initializeWidgets();
          var widget = document.querySelector(".jdgm-review-widget");
          if (widget) {
            setTimeout(function() {
              widget.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 600);
          }
        }
      };
      document.head.appendChild(s);
    }
    if (document.readyState === "complete") {
      loadV2AndInit();
    } else {
      window.addEventListener("load", loadV2AndInit);
    }
  }
})();